/**
 * Send a message using intercom's bot. This is kind of a hack but it works.
 * Caller is expected to test that intercom is even loaded.
 *
 * @param {*} message
 * @param {*} userinfo
 * @param {*} autosend
 */
export default function sendIntercomMessage(message, userinfo, autosend) {
  let {name, email} = userinfo || {};
  if (name || email) Intercom("update", { name, email });
  Intercom("showNewMessage", message);

  if (!autosend) return;

  // Click the send button within intercom
  // If this fails, user will need to click manually
  setTimeout(() => {
    try {
      document
        .querySelector("iframe[name=intercom-messenger-frame]")
        .contentDocument.querySelector(".intercom-composer-send-button")
        .click();
    } catch (e) {
      console.error(e);
    }
  }, 250);
}



// WEBPACK FOOTER //
// ./src/lib/integrations/sendIntercomMessage.js